import { Divider, Flex, PaperSection, SectionTitle } from '@shared/components';

import {
  BlocklistProctorInformationFields,
  type BlocklistProctorInformationFieldsProps,
} from '../blocklist-proctor-information-fields';
import {
  EmployeeInformationFields,
  type EmployeeInformationFieldsProps,
} from '../employee-information-fields';
import {
  ExamSessionInformationFields,
  type ExamSessionInformationFieldsProps,
} from '../exam-session-information-fields';

export type BlockedExamPasserFieldsProps = EmployeeInformationFieldsProps &
  BlocklistProctorInformationFieldsProps &
  ExamSessionInformationFieldsProps;

export default function BlockedExamPasserFields(props: Readonly<BlockedExamPasserFieldsProps>) {
  const { fields, visibleFields, options, slots } = props;
  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <PaperSection title='ข้อมูลการระงับสิทธิ์สอบ'>
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
        >
          <SectionTitle title='Personal Information' />
          <EmployeeInformationFields fields={fields} visibleFields={visibleFields} />
        </Flex>
        <Divider />
        <BlocklistProctorInformationFields fields={fields} options={options} slots={slots} />
        <Divider />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
        >
          <SectionTitle title='Exam Session' />
          <ExamSessionInformationFields fields={fields} />
        </Flex>
        <Divider />
      </PaperSection>
    </Flex>
  );
}
